import React from 'react';

function OneClick() {
    return (
        <div
            className="modal fade show"
            id="modal-form-buy"
            tabIndex={-1}
            aria-modal="true"
            role="dialog"
            style={{ display: 'block' }}
        >
            <div className="modal-dialog">
                <div className="modal-content modal-form js-modal-form">
                    <button
                        aria-label="Close"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        type="button"
                    >
                        <svg className="close">
                            <use xlinkHref="/catalog/view/theme/gbiv2/img/icons.svg#close"></use>
                        </svg>
                    </button>
                    <h2>Заказ в 1 клик</h2>

                    <form
                        className="form-fb js-make-question"
                        js-x-subject="Заказ в 1 клик"
                    >
                        <input
                            type="text"
                            className="form-control"
                            id="guard-form"
                            name="guard-form"
                            value="73"
                            style={{ display: 'none' }}
                            readOnly
                        />
                        <input type="hidden" name="subject" value="Заказ 1 клик" />

                        <div className="form-item">
                            <label className="form-label" htmlFor="InputName">
                                Ваше имя*
                            </label>
                            <input
                                aria-describedby="InputNameHelp"
                                name="name"
                                className="form-control"
                                id="InputName"
                                placeholder="Иван Петров"
                                type="text"
                            />
                        </div>

                        <div className="form-item">
                            <label className="form-label" htmlFor="InputPhone">
                                Ваш телефон*
                            </label>
                            <input
                                className="form-control"
                                name="phone"
                                id="InputPhone"
                                placeholder="+7 (___) ___-__-__"
                                type="tel"
                            />
                        </div>

                        <div className="form-item">
                            <label className="form-label" htmlFor="InputEmail">
                                Ваш email*
                            </label>
                            <input
                                className="form-control"
                                name="email"
                                id="InputEmail"
                                placeholder="e-mail"
                                type="email"
                            />
                        </div>

                        <input type="hidden" name="description" value="" />

                        <div className="form-item product-desc"></div>

                        <div className="form-item form-check">
                            <input
                                className="form-check-input"
                                name="agreement"
                                id="Check3"
                                type="checkbox"
                            />
                            <label className="form-check-label" htmlFor="Check3">
                                Я соглашаюсь с условиями обработки моих персональных данных
                                <br />
                                <a href="">Подробнее</a>
                            </label>
                        </div>

                        <button className="btn" type="submit">
                            Купить
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default OneClick;
